<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div class="col-12 p-0 m-0">
      <user-selector @event-change-member="onChange"></user-selector>
    </div>
    <div class="text-right col-12 p-0 m-0 mt-1 text-right">
      <button type="submit" class="btn skin btn-primary mt-1" @click="openTeamInvite">{{$t('invite_new_members')}}</button>
      <button type="submit" class="btn skin btn-primary mt-1" @click="createTeamMember">{{buttontext}}</button>
    </div>

    <team-registration-invite ref="teamRegsitrationInviteSelector"></team-registration-invite>
  </div>
</template>

<script>
  import MemberSelector from '../user/user-selector.vue'
  import TeamRegisterInvite from "./team-registration-invite.vue";
  let message = "";
  var selected = "";
  let displayAddMember = false;
  var teamMemberName = "";
  var placeholder = "";
  var buttontext = "";

  export default {
    name: "add-teammember-selector",
    components: {
      MemberSelector,
      TeamRegisterInvite
    },
    props: {
      
    },
    data() {
      return {
        placeholder,
        buttontext,
        selected,
        message: "",
        visible: this.visibility,
        displayAddMember: false,
        teamMemberName,
        teamId:-1
      };
    },
    methods: {
      openTeamInvite() {
        this.$refs.teamRegsitrationInviteSelector.open(this.teamId);
      },
      displayAddMemberForm() {
        this.displayAddMember = !this.displayAddMember;
      },
      onChange(memberName) {        
        this.teamMemberName = memberName;
      },
      getId() {
        return this._uid;
      },
      doChange() {
        this.selected = $("#" + 'select_' + this.getId()).val();
      },
      async createTeamMember() {        
        var request = { name: this.teamMemberName, teamId: this.teamId };
        try {
          var response = await this.$http.post(
            '/api/Teams/v1/Members',
            request
          ).then(async response => {
            this.displayAddMember = false;
            this.$emit('event-refresh-teammembers');
          });

        } catch (err) {
          alert(err);
        }
      },

    },
    watch: {

    },
    mounted() {
      this.placeholder = this.$store.translate('select_team');
      this.buttontext = this.$store.translate('add_team_member');
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/team/add-teammember-selector.vue